import { Button } from "@material-ui/core";
import { useCallback } from "react";
import { AmenityDefinitionDisclaimer } from "../../../graphql/models";
import { I18NTextField } from "../i18n_text_field";

export type AmenityDisclaimersProps = {
  disclaimers: AmenityDefinitionDisclaimer[];
  onChange: (v: AmenityDefinitionDisclaimer[]) => void;
};
export function AmenityDisclaimers(props: AmenityDisclaimersProps) {
  const { disclaimers, onChange } = props;

  const add = useCallback(() => {
    onChange([
      ...disclaimers,
      {
        i18n: {},
      },
    ]);
  }, [disclaimers, onChange]);

  const triggerChange = useCallback(
    (v: AmenityDefinitionDisclaimer["i18n"], idx: number) => {
      const cp = [...disclaimers];

      cp.splice(idx, 1, {
        i18n: v,
      });

      onChange(cp);
    },
    [disclaimers, onChange]
  );

  return (
    <ul>
      {disclaimers.map((v, i) => (
        <li key={v.i18n?.title_it ?? i}>
          <I18NTextField
            label="Titolo"
            value={v.i18n}
            i18nFieldName="title"
            onChange={(v) => triggerChange(v, i)}
          />
          <I18NTextField
            label="Descrizione"
            value={v.i18n}
            i18nFieldName="description"
            onChange={(v) => triggerChange(v, i)}
          />
        </li>
      ))}
      <Button variant="contained" onClick={add}>
        Aggiungi una categoria nella pagina principale
      </Button>
    </ul>
  );
}
